import { Box, Button, Highlight, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiGestorMed } from "../api/ApiGMed";
import React from 'react';
import {ApiTallos} from "../api/ApiTallos";


export default function ModalConfirm(props) {
    const {isOpen, onOpen, onClose} = useDisclosure(),
        [blockButtons, setBlockButtons] = useState(false),
        toast = useToast(),
        navigate = useNavigate(),
        [dados, setDados] = useState([]),
        [precos, setPrecos] = useState([]);

    const getValoresProcedimentos= async (idProcedimento)=>{
        const response = await ApiGestorMed.getConvenios(idProcedimento);
        if(response.length>0){
            const menorPreco=filtraMenorPreco(response)
            setPrecos(menorPreco.preco);
        }
    }
    function filtraMenorPreco(convenios) {
        return convenios.reduce((menor, atual) => {
            return atual.preco < menor.preco ? atual : menor;
        });
    }

    useEffect(() => {
        if (props.hable) {
            onOpen();
            setDados(props.dataUser)
            getValoresProcedimentos(props.dataUser.idProcedimento)
        }
        ;
    }, []);

    const handleBack = () => {
        props.close();
    };
    const handleSubmit = async () => {
        setBlockButtons(true);
        const {nomePaciente, procedimento, data, telefone} = props.dataUser;
        const variaveis = [
            nomePaciente,
            data,
            procedimento,
        ];
        const confirm = await ApiGestorMed.setAtendimento(props.dataUser);
        if (confirm.status === 200) {
            const message = await ApiTallos.sendMessage(telefone, variaveis)
            toast({
                title: `Sua consulta foi agendada com sucesso!`,
                status: "success"
            });
            setTimeout(() => {
                navigate("/")
            }, "2000")
        } else {
            toast({
                title: `Houve um problema ao agendar sua consulta!`,
                status: "error"
            });
            setTimeout(() => {
                navigate("/")
            }, "2000")
        }
    }
    function limitarTexto(texto, maxCaracteres) {
        // Verifica se 'texto' é uma string antes de continuar
        if (typeof texto !== "string") {
            return "";  // Retorna uma string vazia ou outro valor padrão
        }

        // Limita o texto e adiciona "..." se necessário
        if (texto.length > maxCaracteres) {
            return texto.slice(0, maxCaracteres) + "...";
        }
        return texto;
    }


    return (
        <>
            <Modal isOpen={isOpen} onClose={handleBack} closeOnOverlayClick={false}>
                <ModalOverlay/>
                <ModalContent color={'black'}>
                    <ModalHeader textAlign={'center'}>Pronto, falta pouco para finalizarmos o agendamento!</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <Box textAlign={'start'}>
                            <Text textAlign={'center'} fontSize={'1rem'} backgroundColor={'red'}><b>CONFIRA SE OS DADOS
                                ESTÃO CORRETOS</b></Text>
                            <HStack>
                                <Text fontWeight="bold">Nome do paciente:</Text>
                                <Text textDecoration={'underline'}>{dados.nomePaciente}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Contato do paciente:</Text>
                                <Text textDecoration={'underline'}>{dados.telefone}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Data marcada:</Text>
                                <Text textDecoration={'underline'}>{dados.data}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Profissional:</Text>
                                <Text textDecoration={'underline'}>{limitarTexto(dados.nomeMedico,30)}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Procedimento:</Text>
                                <Text textDecoration={'underline'}>{dados.procedimento}</Text>
                            </HStack>
                            {dados.horario ?
                                <HStack>
                                    <Text fontWeight="bold">Horario:</Text>
                                    <Text textDecoration={'underline'}> {dados.horario}</Text>
                                </HStack>
                                : null}
                            {dados.obs ?
                                <Text textDecoration={'underline'}><b>ATENÇÃO: {dados.obs}</b></Text>
                                : null}
                            {dados.unidade == 2 ?
                                <HStack>
                                    <Text fontWeight="bold">Unidade:</Text>
                                    <Text textDecoration={'underline'}> SESC CIDADE ALTA</Text>
                                </HStack>
                                :
                                <HStack>
                                    <Text fontWeight="bold">Unidade:</Text>
                                    <Text textDecoration={'underline'}> SESC MOSSORÓ</Text>
                                </HStack>

                            }
                            {/*<HStack mt={'10px'}>*/}
                            {/*<Text as={'b'}  backgroundColor={'yellow.100'} textAlign={'center'}> <i>Estou ciente, que os valores de consultas e procedimentos serão*/}
                            {/*    atualizados para 2025.</i> </Text>*/}
                            {/*</HStack>*/}
                            {precos &&
                                <HStack>
                                    <Text fontWeight="bold">Preços:</Text>
                                    <Text textDecoration={'underline'}> A PARTIR DE R${precos}</Text>
                                </HStack>
                            }
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme={'green'} mr={3} onClick={handleSubmit} disabled={blockButtons}>
                            Confirmar agendamento
                        </Button>
                        <Button colorScheme={'blue'} mr={3} onClick={handleBack}>
                            Fechar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}